/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ObservableCircle.ts
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 1032
 * ---
 * Description:
 */

import Pamela from '@revodigital/pamela';
import {
  action,
  computed,
  makeObservable,
  observable
}             from 'mobx';
import {
  Editor
}             from './Editor';
import {
  defaultSetterOptions,
  ObservableSetterOptions,
  ObservableShape
}             from './ObservableShape';

export class ObservableCircle extends ObservableShape<Pamela.Circle> {
  @observable
  private _radius: number;

  constructor(shape: Pamela.Circle, editor: Editor) {
    super(shape, editor);
    this._radius = editor.pixelToCurrent(shape.radius());
    makeObservable(this);
  }

  @computed
  public get radius() {
    return this._radius;
  }

  @action
  public setRadius(value: number, options: ObservableSetterOptions = defaultSetterOptions) {
    this._radius = Math.round(value);
    if (options.applyToPamelaShape)
      this.pamelaShape__nonObservable.radius(this.editor.currentToPixel(
        value));
    this.editor.history.takeSnapshot();
  }
}